module.exports = __webpack_public_path__ + "static/media/party-catering-3.0b4298bf.jpg";